/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useSelector } from 'react-redux';

const Table = ({
    pageNumber, 
    getListData, 
    setToastErrorMessage, 
    searchParams,
    setConfirmationState, handleSidePopupClick,email,setLoading}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const PurchaseOrderList = useSelector(state => state.purchaseOrderListSlice);
    const { List} = PurchaseOrderList
    
    
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */
    
  
    return (<>
        
        <div className={`flex mb-3 overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full" id='admin-table'>
                <thead>
                    <tr class="h-[38px] w-full bg-[#C2DCEF] shadow-s13 rounded-[16px]">
                        <th class="px-3 pl-[35px] pr-[86px] py-3 w-[150px] rounded-tl-[16px] rounded-bl-[16px]">
                            <span class="flex items-start justify-start text-f2 font-semibold text-[#031624]">Month
                            </span>
                        </th>
                        <th class="px-3 py-3 ">
                            <span class="flex items-start justify-start text-f2 font-semibold text-[#031624]">Actions
                            </span>
                        </th>
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                            
                </thead>
                <tbody>
                    {List?.data?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                setConfirmationState={setConfirmationState}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                email={email}
                                searchParams={searchParams}
                                handleSidePopupClick={handleSidePopupClick}
                                getListData={getListData}
                                setLoading={setLoading}
                                setToastErrorMessage={setToastErrorMessage}
                                branch_data={List?.branch_data}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {(List?.data?.length === 0) && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                {`No payrolls uploaded for the FY`}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
